import { IDataStorage } from "../internal/data-storage";
import { InternalTable } from "../internal/internal-table";
import { InternalIndex } from "@stockcare-storage/internal/internal-index";

export class BasketStaging implements IDataStorage {
  patientIdIndex: InternalIndex = new InternalIndex(
    "PatientId",
    "PatientId",
    false,
    false
  );
  clientIdIndex: InternalIndex = new InternalIndex(
    "ClientId",
    "ClientId",
    true,
    false
  );
  tableDefinition: InternalTable = new InternalTable(
    "BasketStaging",
    "Id",
    true,
    [this.patientIdIndex, this.clientIdIndex]
  );

  Id: number;
  PatientId: number;
  BasketJson: string;
  PatientStocksJson: string;
  ClientId: string;
  Processed: boolean;
  QueueId: string;
  Date: Date;
  ExpiryDate: Date;
  Department: string;
  NursingOrganizationUnit: string;

  static getTableDefinition(): InternalTable {
    return new BasketStaging().tableDefinition;
  }
}
